import request from 'utils/request';
import configs from 'configs';

const { fileServiceUrl } = configs;

const slugs = ['tag.value'];
const listSlugs = ['tags.value'];

export async function query(params) {
  return request({
    url: `${fileServiceUrl}/tags`,
    method: 'get',
    data: params,
    slugs: listSlugs,
  });
}

export async function create(params) {
  return request({
    url: `${fileServiceUrl}/tags`,
    method: 'post',
    data: params,
    slugs,
  });
}

export async function remove(params) {
  return request({
    url: `${fileServiceUrl}/tags/${params.id}`,
    method: 'delete',
  });
}



// WEBPACK FOOTER //
// ./src/services/file_tag.js